var $ = global.jQuery = global.$;

require('../third-party/mousewheel.min.js');
require('../third-party/mCustomScrollbar.js');

var _Base = require('./_Base');

/**
 * Implementation of mCustomScrollbar plugin {@link http://manos.malihu.gr/jquery-custom-content-scroller/}
 * @class
 * @extends _Base
 */
var FakeScroll = _Base.extend(
  /** @lends FakeScroll.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.$el.mCustomScrollbar({
      theme: 'dark',
      autoHideScrollbar: true,
    });

  }
});

module.exports = FakeScroll;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/FakeScroll.js
 ** module id = 46
 ** module chunks = 0 1
 **/